<template lang="pug">
  .ecommerce-config
    .title Configuración Ecommerce
    .ecommerce-config-list(v-if="configs.length > 0")
      .ecommerce-config-item(v-for="config in configs" :key="config.brand")
        .dark {{ config.brand }}

        .section
          label Artículos
          .tags
            .tag(v-for="(art, i) in config.articles" :key="i")
              input(type="text" v-model="art.article" placeholder="artículo")
              button.remove(@click="config.articles.splice(i, 1)") ✕
            button.add(@click="config.articles.push({ article: '' })") + Agregar artículo

        .section
          label Mínimo de compra para envío gratis (subtotal tras descuentos; $ COP)
          input.delivery-minimum(
            type="number"
            min="0"
            step="1000"
            v-model.number="config.deliveryMinimum"
          )

        .section
          label Costo envío Bogotá / Cundinamarca ($ COP)
          input.delivery-minimum(
            type="number"
            min="0"
            step="1000"
            v-model.number="config.conveyorCostMetroZone"
          )

        .section
          label Costo envío otras ciudades ($ COP)
          input.delivery-minimum(
            type="number"
            min="0"
            step="1000"
            v-model.number="config.conveyorCostOtherZone"
          )

        .section
          label Plazo para solicitar reembolsos (días naturales desde la entrega)
          input.delivery-minimum(
            type="number"
            min="0"
            step="1"
            v-model.number="config.refundRequestMaxDays"
          )
          .hint El cliente puede solicitar reembolso hasta este número de días después de la fecha de entrega registrada.

        .section
          label Grupos de tallas
          .size-group(v-for="(group, gi) in config.sizes" :key="gi")
            .size-group-header
              input(type="text" v-model="group.type" placeholder="tipo (ej: superior)")
              button.remove(@click="config.sizes.splice(gi, 1)") ✕ grupo
            .tags
              .tag(v-for="(s, si) in group.sizes" :key="si")
                input(type="text" v-model="s.size" placeholder="talla")
                button.remove(@click="group.sizes.splice(si, 1)") ✕
              button.add(@click="group.sizes.push({ size: '' })") + Agregar talla
          button.add(@click="config.sizes.push({ type: '', sizes: [] })") + Agregar grupo de tallas

        div
          shActionButton(text="Guardar" :action="save" :params="[config]" :principalColor="true")
</template>

<script>
import gqlEcommerceConfig from '@/graphql/ecommerceConfig'
import gql from '@my/graphql'
import shActionButton from '@/components/elements/ActionButton'
import modals from '@my/store/modals'

export default {
  name: 'EcommerceConfig',

  components: { shActionButton },

  data () {
    return {
      configs: []
    }
  },

  mounted () {
    if (this.brands && this.brands.length > 0) {
      this.getConfig()
    }
  },

  computed: {
    brands () {
      return this.$store.state.variables.brands
    }
  },

  watch: {
    brands () {
      this.getConfig()
    }
  },

  methods: {
    async getConfig () {
      const { data } = await gql.query(gqlEcommerceConfig.GET_ALL)
      const existing = {}
      data.getEcommerceConfig.forEach(c => {
        existing[c.brand] = {
          brand: c.brand,
          deliveryMinimum: c.deliveryMinimum,
          conveyorCostMetroZone: c.conveyorCostMetroZone != null ? c.conveyorCostMetroZone : 0,
          conveyorCostOtherZone: c.conveyorCostOtherZone != null ? c.conveyorCostOtherZone : 0,
          refundRequestMaxDays: c.refundRequestMaxDays != null ? c.refundRequestMaxDays : 30,
          articles: c.articles.map(a => ({ article: a.article })),
          sizes: c.sizes.map(g => ({
            type: g.type,
            sizes: g.sizes.map(s => ({ size: s.size }))
          }))
        }
      })

      this.configs = this.brands.map(brand => existing[brand] || {
        brand,
        deliveryMinimum: null,
        conveyorCostMetroZone: 0,
        conveyorCostOtherZone: 0,
        refundRequestMaxDays: 30,
        articles: [],
        sizes: []
      })
    },

    async save (config) {
      const articles = config.articles.filter(a => a.article.trim())
      const sizes = config.sizes
        .filter(g => g.type.trim())
        .map(g => ({
          type: g.type.trim(),
          sizes: g.sizes.filter(s => s.size.trim()).map(s => ({ size: s.size.trim() }))
        }))

      if (articles.length === 0) {
        modals.showMessage({ message: 'Agrega al menos un artículo', type: 'error' })
        return
      }

      const rawDm = config.deliveryMinimum
      const deliveryMinimum =
        rawDm === '' || rawDm === null || rawDm === undefined
          ? NaN
          : Number(rawDm)
      if (Number.isNaN(deliveryMinimum) || deliveryMinimum < 0) {
        modals.showMessage({ message: 'Indica un mínimo de compra válido (número mayor o igual a 0)', type: 'error' })
        return
      }

      const rawMetro = config.conveyorCostMetroZone
      const conveyorCostMetroZone =
        rawMetro === '' || rawMetro === null || rawMetro === undefined
          ? NaN
          : Number(rawMetro)
      const rawOther = config.conveyorCostOtherZone
      const conveyorCostOtherZone =
        rawOther === '' || rawOther === null || rawOther === undefined
          ? NaN
          : Number(rawOther)
      if (Number.isNaN(conveyorCostMetroZone) || conveyorCostMetroZone < 0 ||
          Number.isNaN(conveyorCostOtherZone) || conveyorCostOtherZone < 0) {
        modals.showMessage({ message: 'Indica los costos de envío (valores válidos mayor o igual a 0)', type: 'error' })
        return
      }

      const rawRefundDays = config.refundRequestMaxDays
      const refundRequestMaxDays =
        rawRefundDays === '' || rawRefundDays === null || rawRefundDays === undefined
          ? NaN
          : Number(rawRefundDays)
      if (Number.isNaN(refundRequestMaxDays) || refundRequestMaxDays < 0 || !Number.isInteger(refundRequestMaxDays)) {
        modals.showMessage({ message: 'Indica un plazo de reembolsos válido (entero mayor o igual a 0)', type: 'error' })
        return
      }

      await gql.mutate(gqlEcommerceConfig.UPDATE, {
        brand: config.brand,
        articles,
        sizes,
        deliveryMinimum,
        conveyorCostMetroZone,
        conveyorCostOtherZone,
        refundRequestMaxDays
      })

      modals.showMessage({ message: `Configuración de ${config.brand} actualizada`, type: 'ok' })
    }
  }
}
</script>

<style lang="stylus" scoped>
.hint
  font-size 0.82rem
  opacity 0.75
  margin-top -0.2rem

.ecommerce-config-list
  display flex
  flex-direction column
  gap 2rem
  padding 1rem
  align-items center

.ecommerce-config-item
  display flex
  flex-direction column
  gap 1rem
  padding 1.5rem
  border-radius 1rem
  border 1px solid rgba(0, 0, 0, 0.1)
  width 100%
  max-width 600px

.section
  display flex
  flex-direction column
  gap 0.5rem

.tags
  display flex
  flex-wrap wrap
  gap 0.5rem
  align-items center

.delivery-minimum
  max-width 220px
  padding 0.3rem 0.5rem
  border 1px solid rgba(0, 0, 0, 0.2)
  border-radius 0.3rem

.tag
  display inline-flex
  align-items center
  gap 0.3rem
  input
    width 120px
    padding 0.3rem 0.5rem
    border 1px solid rgba(0, 0, 0, 0.2)
    border-radius 0.3rem

.size-group
  margin-bottom 0.5rem
  padding 0.5rem
  border-left 3px solid rgba(0, 0, 0, 0.1)

.size-group-header
  display flex
  align-items center
  gap 0.5rem
  margin-bottom 0.5rem
  input
    padding 0.3rem 0.5rem
    border 1px solid rgba(0, 0, 0, 0.2)
    border-radius 0.3rem

button.add
  padding 0.3rem 0.8rem
  border none
  border-radius 0.3rem
  background rgba(0, 0, 0, 0.05)
  cursor pointer
  font-size 0.85rem
  &:hover
    background rgba(0, 0, 0, 0.1)

button.remove
  padding 0.2rem 0.5rem
  border none
  background transparent
  cursor pointer
  color #c00
  font-size 0.85rem
  &:hover
    background rgba(200, 0, 0, 0.1)
    border-radius 0.3rem
</style>



// WEBPACK FOOTER //
// src/components/pages/ecommerceConfig/EcommerceConfig.vue